import React from "react";
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';

function InputMaskOfficeFA(props) {
  const { inputRef, onChange, ...inputMaskProps } = props;

  return (
    <InputMask
      {...inputMaskProps}
      inputRef={inputRef}
      onChange={onChange}
      maskChar=""
      mask="***-***"
      formatChars={{"*": "[0-9]"}}
    />
  );
}

function InputMaskFANumber(props){
  const { inputRef, onChange, ...inputMaskProps } = props;

  return (
    <InputMask
      {...inputMaskProps}
      inputRef={inputRef}
      onChange={onChange}
      maskChar=""
      mask="***"
      formatChars={{"*": "[0-9]"}}
    />
  );
}

function InputMaskOfficeAccount(props) {
  const { inputRef, onChange, ...inputMaskProps } = props;

  return (
    <InputMask
      {...inputMaskProps}
      inputRef={inputRef}
      onChange={onChange}
      maskChar=""
      mask="***-******"
      formatChars={{"*": "[0-9]"}}
    />
  );
}

export { InputMaskOfficeAccount, InputMaskOfficeFA, InputMaskFANumber};

InputMaskOfficeFA.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
}

InputMaskOfficeAccount.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Formatters/InputMaskClientAccount.js